import gql from 'graphql-tag';
import lightModeFields from '@/queries/fields/lightModeFields';

const lightStateFields = gql`
  fragment lightStateFields on LightState {
    dimming
    speed
    ratio
    status
    fanState
    fanSpeed
    fanMode
    fanReverse
    mode {
      ...lightModeFields
    }
  }
  ${lightModeFields}
`;

export default lightStateFields;
